module.exports = __webpack_public_path__ + "img/gal-8.68c84fcf.jpg";